<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Documentos" />
  <menuLateral />
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="card">
        <div class="card-body">
          <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">
              <div class="row">
                <div class="form-group col-sm-10 col-md-11 col-lg-11 col-xl-11">
                  <b-form-group label="Categoria" label-for="categoriaFiltro" label-align-sm="left" label-size="sm" class="mb-1"></b-form-group>
                  <b-form-select id="inputCategory" v-model="category" :options="comboCategorias" value-field="category" text-field="category" :disabled="flagsDeControle.carregandoDados.status" size="sm" class="comboFonteDefault">
                    <template #first>
                      <b-form-select-option :value="null">Todas</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
                <div class="form-group text-right col-sm-2 col-md-1 col-lg-1 col-xl-1">
                  <b-button class="botoes" style="margin-top: 2.5rem;" variant="outline-primary btn-sm" @click="buscarRegistros()" :disabled="flagsDeControle.carregandoDados.status">Buscar</b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div v-if="tabelaSemRegistros" class="col-12 text-center font-italic">
              <span>Nenhum registro encontrado.</span>
            </div>
            <div v-else v-for="(campo, indice) in listaDocumentos" :key="campo.id" :index="indice" class="col-12 col-sm-6 col-md-3">
              <div class="card bg-light d-flex flex-fill">
                <span class=" mt-2 ml-2">{{campo.category}}</span><hr>
                <div class="card-header titulos-conteudo border-bottom-0">{{campo.title}}</div>
                <div class="card-body pt-0">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        <small class="text-muted">{{campo.category}}</small>
                        <br/>
                        <small class="text-muted">{{$date(campo.created_at).format('DD/MM/YYYY HH:mm')}}</small>
                        <br/>
                        <small class="text-muted">Publicado por: {{campo.publisher_relation.f_name}}</small>
                      </p>
                    </div>
                    <div class="col-12">
                      <p class="card-text textos">{{campo.summary}}</p>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-right">
                   <div class="row btn-group btn-group-justified" role="group">
                    <spinnerProcessando cssClass="mr-2" :status="flagsDeControle.carregandoArquivo.status[indice]"/>
                    <b-button class="botoes" variant="outline-primary btn-sm mt-2" @click="baixarDocumento(campo.id, campo.file_original_name, indice)" :disabled="!campo.has_file || flagsDeControle.carregandoDados.status">Download</b-button>
                   </div>
                </div>
              </div>
            </div>
          </div>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status || tabelaSemRegistros" @navegarNaPaginacao="obterDadosPaginados"/>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Documentos from './js'
export default Documentos
</script>

<style scoped>
@import "./scss/documentos.scss";
</style>
